export default __webpack_public_path__ + "static/media/Screenshot (1074).d133a5f8.png";